const _ = require('core/src/utils/legacy');

const typeProperties = {
	Date: ['day', 'month', 'year'],
	DateTime: ['year', 'month', 'day', 'hour', 'minute', 'second', 'nanosecond', 'timeZoneOffsetSeconds', 'timeZoneId'],
	DateTimeAlt: ['year', 'month', 'day', 'hour', 'minute', 'second', 'nanosecond', 'timeZoneOffsetSeconds'],
	Duration: ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds', 'nanoseconds'],
	ValidDuration: ['months', 'days', 'seconds', 'nanoseconds'],
	ValidDurationMemgraph: ['days', 'seconds', 'nanoseconds'],
	ValidDurationFalkorDB: ['years', 'months', 'days', 'hours', 'minutes', 'seconds', 'nanoseconds'],
	LocalDateTime: ['year', 'month', 'day', 'hour', 'minute', 'second', 'nanosecond'],
	LocalTime: ['hour', 'minute', 'second', 'nanosecond'],
	Time: ['hour', 'minute', 'second', 'nanosecond', 'timeZoneOffsetSeconds'],
	ValidPoint2D: ['srid', 'x', 'y'],
	Point2D: ['srid', 'x', 'y', 'latitude', 'longitude'],
	ValidPoint3D: ['srid', 'x', 'y', 'z'],
	Point3D: ['srid', 'x', 'y', 'z', 'latitude', 'longitude', 'height'],
	Location: ['latitude', 'longitude']
};

const driverUnsupportedTypes = {
	falkordb: ['time', 'datetime', 'point2d', 'point3d', 'object'],
	neo4j: ['object']
};

const driverOnlyTypes = {};

const conversionTypeAliases = {
	Auto: 'auto',
	Text: 'string',
	String: 'string',
	Number: 'number',
	Boolean: 'boolean',
	Date: 'date',
	LocalTime: 'localtime',
	Time: 'time',
	LocalDateTime: 'localdatetime',
	DateTime: 'datetime',
	Array: 'array',
	Object: 'object',
	Json: 'json',
	JSON: 'json',
	Point2D: 'point2d',
	Point3D: 'point3d',
	Location: 'location',
	Duration: 'duration'
};

const zonedDateTimeReg = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})[T ](?<hour>\d{2}):(?<minute>\d{2})(:(?<second>\d{2}))?(\.(?<nanosecond>\d{1,9}))?\s?(?<tz>Z|[+-]\d{2}:\d{2})$/;
const zonedTimeReg = /^(?<hour>\d{2}):(?<minute>\d{2})(:(?<second>\d{2}))?(\.(?<nanosecond>\d{1,9}))?\s?(?<tz>Z|[+-]\d{2}:\d{2})$/;
const localDateTimeReg = /^(?<year>\d{4})[-./](?<month>\d{2})[-./](?<day>\d{2})[T ](?<hour>\d{2}):(?<minute>\d{2})(:(?<second>\d{2}))?(\.(?<nanosecond>\d{1,9}))?$/;
const localTimeReg = /^(?<hour>\d{2}):(?<minute>\d{2})(:(?<second>\d{2}))?$/;
const dateReg = /^(?<year>\d{4})[-./](?<month>\d{2})[-./](?<day>\d{2})$/;
const durationReg = /^P(?<years>\d+(?:\.\d+)?Y)?(?<months>\d+(?:\.\d+)?M)?(?<weeks>\d+(?:\.\d+)?W)?(?<days>\d+(?:\.\d+)?D)?(?:T(?<hours>\d+(?:\.\d+)?H)?(?<minutes>\d+(?:\.\d+)?M)?(?<seconds>\d+(?:\.\d+)?S)?)?$/;
const wkt2DReg = /^(?:SRID=(?<srid>\d+);)?POINT\s*\(\s*(?<x>-?\d+(?:\.\d+)?)\s+(?<y>-?\d+(?:\.\d+)?)\s*\)$/i;
const cypherPoint2DReg = /^point\s*\(\s*\{\s*(?:srid\s*:\s*(?<srid>\d+)\s*,\s*)?(?:x\s*:\s*(?<x>-?\d+(?:\.\d+)?)|longitude\s*:\s*(?<lon>-?\d+(?:\.\d+)?))\s*,\s*(?:y\s*:\s*(?<y>-?\d+(?:\.\d+)?)|latitude\s*:\s*(?<lat>-?\d+(?:\.\d+)?))\s*\}\s*\)$/i;
const driverPoint2DReg = /^Point\{srId=(?<srid>\d+),\s*x=(?<x>-?\d+(?:\.\d+)?),\s*y=(?<y>-?\d+(?:\.\d+)?)\}$/;
const wkt3DReg = /^(?:SRID=(?<srid>\d+);)?POINT\s+Z\s*\(\s*(?<x>-?\d+(?:\.\d+)?)\s+(?<y>-?\d+(?:\.\d+)?)\s+(?<z>-?\d+(?:\.\d+)?)\s*\)$/i;
const cypherPoint3DReg = /^point\s*\(\s*\{\s*(?:srid\s*:\s*(?<srid>\d+)\s*,\s*)?(?:x\s*:\s*(?<x>-?\d+(?:\.\d+)?)|longitude\s*:\s*(?<lon>-?\d+(?:\.\d+)?))\s*,\s*(?:y\s*:\s*(?<y>-?\d+(?:\.\d+)?)|latitude\s*:\s*(?<lat>-?\d+(?:\.\d+)?))\s*,\s*(?:z\s*:\s*(?<z>-?\d+(?:\.\d+)?)|height\s*:\s*(?<h>-?\d+(?:\.\d+)?))\s*\}\s*\)$/i;
const driverPoint3DReg = /^Point\{srId=(?<srid>\d+),\s*x=(?<x>-?\d+(?:\.\d+)?),\s*y=(?<y>-?\d+(?:\.\d+)?),\s*z=(?<z>-?\d+(?:\.\d+)?)\}$/;

const hasOnlyProps = (obj, props) => _.size(obj) === _.size(props) && _.every(props, key => _.has(obj, key));
const hasOnlyPropsSubset = (obj, props) => _.isPlainObject(obj) && _.every(_.keys(obj), key => props.includes(key));
const hasAnyProps = (obj, props) => _.some(props, key => _.has(obj, key));

function createConversionError(message) {
	return new _.Error(message);
}

function normalizeConversionType(type) {
	type = _.toString(type || 'auto').trim();
	const normalized = _.toLower(type);
	return conversionTypeAliases[type] || (normalized === 'text' ? 'string' : normalized);
}

function normalizeConversionOptions(options = {}) {
	if (!_.isPlainObject(options)) {
		throw createConversionError('Conversion options must be an object.');
	}
	return {
		type: normalizeConversionType(options.type),
		driver: _.toLower(options.driver || ''),
		strict: options.strict !== false
	};
}

function isTypeSupported(type, driver) {
	const unsupported = driver ? (driverUnsupportedTypes[driver] || []) : [];
	if (unsupported.includes(type)) {
		return false;
	}
	if (driverOnlyTypes[type] && !driverOnlyTypes[type].includes(driver)) {
		return false;
	}
	return true;
}

function assertTypeSupported(type, driver) {
	if (!isTypeSupported(type, driver)) {
		throw createConversionError(`Type '${type}' is not supported by driver '${driver || 'default'}'.`);
	}
}

function parseJsonString(value) {
	if (!_.isString(value)) {
		return value;
	}

	try {
		return JSON.parse(value);
	} catch (e) {
		throw createConversionError(e.message);
	}
}

function tryParseObjectString(value) {
	if (!_.isString(value)) {
		return value;
	}

	const cleaned = value.trim().replaceAll(/([{,]\s*)([a-zA-Z_]\w*)\s*:/g, '$1"$2":');
	try {
		return JSON.parse(cleaned);
	} catch {
		return value;
	}
}

function toNumber(value) {
	if (_.isNumber(value) && _.isFinite(value)) {
		return value;
	}

	if (!_.isString(value)) {
		throw createConversionError('Value must be a number.');
	}

	const trimmed = _.trim(value);
	const parsed = Number.parseFloat(trimmed);
	if (!_.isNaN(parsed) && _.toString(parsed) === trimmed) {
		return parsed;
	}

	throw createConversionError('Value must be a number.');
}

function toBoolean(value) {
	if (_.isBoolean(value)) {
		return value;
	}
	if (_.isNumber(value) && (value === 1 || value === 0)) {
		return value === 1;
	}
	if (_.isString(value)) {
		const normalized = _.toLower(_.trim(value));
		if (normalized === 'true' || normalized === '1') {
			return true;
		}
		if (normalized === 'false' || normalized === '0') {
			return false;
		}
	}
	throw createConversionError('Value must be a boolean.');
}

function toNanoseconds(value) {
	return _.toNumber(_.padEnd(_.toString(value || 0), 9, '0'));
}

function offsetToSeconds(tz) {
	if (tz === 'Z') {
		return 0;
	}
	const sign = tz.startsWith('-') ? -1 : 1;
	const parts = _.map(tz.slice(1).split(':'), _.toNumber);
	return sign * ((parts[0] * 3600) + (parts[1] * 60));
}

function toDateObject(value) {
	if (_.isPlainObject(value) && hasOnlyProps(value, typeProperties.Date)) {
		return value;
	}

	const match = _.toString(value).match(dateReg);
	if (!match) {
		throw createConversionError('Value must be a date.');
	}

	return _.mapValues(match.groups, _.toNumber);
}

function toLocalTimeObject(value) {
	if (_.isPlainObject(value) && hasOnlyProps(value, typeProperties.LocalTime)) {
		return value;
	}

	const match = _.toString(value).match(localTimeReg);
	if (!match) {
		throw createConversionError('Value must be a local time.');
	}

	const groups = match.groups;
	return {
		hour: _.toNumber(groups.hour),
		minute: _.toNumber(groups.minute),
		second: _.toNumber(groups.second || 0),
		nanosecond: 0
	};
}

function toTimeObject(value) {
	if (_.isPlainObject(value) && hasOnlyProps(value, typeProperties.Time)) {
		return value;
	}

	const match = _.toString(value).match(zonedTimeReg);
	if (!match) {
		throw createConversionError('Value must be a zoned time.');
	}

	const groups = match.groups;
	return {
		hour: _.toNumber(groups.hour),
		minute: _.toNumber(groups.minute),
		second: _.toNumber(groups.second || 0),
		nanosecond: toNanoseconds(groups.nanosecond),
		timeZoneOffsetSeconds: offsetToSeconds(groups.tz)
	};
}

function toLocalDateTimeObject(value) {
	if (_.isPlainObject(value) && hasOnlyProps(value, typeProperties.LocalDateTime)) {
		return value;
	}

	const match = _.toString(value).match(localDateTimeReg);
	if (!match) {
		throw createConversionError('Value must be a local date-time.');
	}

	const groups = match.groups;
	return {
		year: _.toNumber(groups.year),
		month: _.toNumber(groups.month),
		day: _.toNumber(groups.day),
		hour: _.toNumber(groups.hour),
		minute: _.toNumber(groups.minute),
		second: _.toNumber(groups.second || 0),
		nanosecond: toNanoseconds(groups.nanosecond)
	};
}

function toDateTimeObject(value) {
	if (_.isPlainObject(value) && (hasOnlyProps(value, typeProperties.DateTime) || hasOnlyProps(value, typeProperties.DateTimeAlt))) {
		return value;
	}

	const match = _.toString(value).match(zonedDateTimeReg);
	if (!match) {
		throw createConversionError('Value must be a zoned date-time.');
	}

	const groups = match.groups;
	return {
		year: _.toNumber(groups.year),
		month: _.toNumber(groups.month),
		day: _.toNumber(groups.day),
		hour: _.toNumber(groups.hour),
		minute: _.toNumber(groups.minute),
		second: _.toNumber(groups.second || 0),
		nanosecond: toNanoseconds(groups.nanosecond),
		timeZoneOffsetSeconds: offsetToSeconds(groups.tz)
	};
}

function durationNumber(value) {
	if (_.isString(value)) {
		const trimmed = _.trim(value);
		if (!trimmed) {
			return 0;
		}
		const numeric = /[a-zA-Z]$/.test(trimmed) ? trimmed.slice(0, -1) : trimmed;
		const parsed = Number(numeric);
		return _.isFinite(parsed) ? parsed : 0;
	}
	return _.isFinite(value) ? Number(value) : 0;
}

function splitSeconds(value) {
	let seconds = Math.trunc(value);
	let nanoseconds = Math.round((value - seconds) * 1e9);
	if (nanoseconds >= 1e9) {
		seconds += 1;
		nanoseconds -= 1e9;
	}
	return { seconds, nanoseconds };
}

function toDurationObject(value, driver) {
	value = tryParseObjectString(value);
	if (!_.isString(value) && !_.isPlainObject(value)) {
		throw createConversionError('Value must be a duration.');
	}
	if (_.isPlainObject(value) && (!hasAnyProps(value, typeProperties.Duration) || !hasOnlyPropsSubset(value, typeProperties.Duration))) {
		throw createConversionError('Value must be a duration.');
	}

	let groups = value;
	if (_.isString(value)) {
		const match = value.match(durationReg);
		if (!match) {
			throw createConversionError('Value must be a duration.');
		}
		groups = match.groups || {};
	}

	const years = durationNumber(groups.years);
	const months = durationNumber(groups.months);
	const weeks = durationNumber(groups.weeks);
	const days = durationNumber(groups.days);
	const hours = durationNumber(groups.hours);
	const minutes = durationNumber(groups.minutes);
	const seconds = durationNumber(groups.seconds);
	const nanoseconds = durationNumber(groups.nanoseconds);

	if (driver === 'falkordb') {
		const normalized = splitSeconds(seconds + (nanoseconds / 1e9));
		return {
			years: years || 0,
			months: months || 0,
			days: ((weeks * 7) + days) || 0,
			hours: hours || 0,
			minutes: minutes || 0,
			seconds: normalized.seconds || 0,
			nanoseconds: normalized.nanoseconds || 0
		};
	}

	const totalSeconds = (hours * 3600) + (minutes * 60) + seconds + (nanoseconds / 1e9);
	const normalized = splitSeconds(totalSeconds);
	return {
		months: ((years * 12) + months) || 0,
		days: ((weeks * 7) + days) || 0,
		seconds: normalized.seconds || 0,
		nanoseconds: normalized.nanoseconds || 0
	};
}

function inferSRID(dim, crs) {
	if (dim === 2 && crs === 'cartesian') return 7203;
	if (dim === 2 && crs === 'wgs84') return 4326;
	if (dim === 3 && crs === 'cartesian') return 9157;
	if (dim === 3 && crs === 'wgs84') return 4979;
	return undefined;
}

function pickGroup() {
	return _.find(arguments, value => !_.isNil(value) && value !== '');
}

function getPointCRS(groups) {
	if (groups.lon || groups.lat) {
		return 'wgs84';
	}
	return 'cartesian';
}

function getPointSRID(srid, dim, crs) {
	if (srid !== undefined) {
		return Number(srid);
	}
	return inferSRID(dim, crs);
}

function hasPointFields(value, fields) {
	return _.every(fields, field => field in value);
}

function createCartesianPoint(value, dim) {
	return {
		srid: getPointSRID(value.srid, dim, 'cartesian'),
		x: Number(value.x),
		y: Number(value.y),
		z: dim === 3 ? Number(value.z) : undefined
	};
}

function createWgsPoint(value, dim) {
	return {
		srid: getPointSRID(value.srid, dim, 'wgs84'),
		x: Number(value.longitude),
		y: Number(value.latitude),
		z: dim === 3 ? Number(value.height) : undefined
	};
}

function omitUndefinedValues(value) {
	return _.omitBy(value, _.isUndefined);
}

function parsePointObject(value, dim) {
	if (hasPointFields(value, dim === 3 ? ['longitude', 'latitude', 'height'] : ['longitude', 'latitude'])) {
		return omitUndefinedValues(createWgsPoint(value, dim));
	}
	if (hasPointFields(value, dim === 3 ? ['x', 'y', 'z'] : ['x', 'y'])) {
		return omitUndefinedValues(createCartesianPoint(value, dim));
	}
	return undefined;
}

function parseWktPoint(match, dim) {
	return omitUndefinedValues({
		srid: getPointSRID(match.groups.srid, dim, 'cartesian'),
		x: Number(match.groups.x),
		y: Number(match.groups.y),
		z: dim === 3 ? Number(match.groups.z) : undefined
	});
}

function parseCypherPoint(match, dim) {
	const crs = getPointCRS(match.groups);
	return omitUndefinedValues({
		srid: getPointSRID(match.groups.srid, dim, crs),
		x: Number(pickGroup(match.groups.x, match.groups.lon)),
		y: Number(pickGroup(match.groups.y, match.groups.lat)),
		z: dim === 3 ? Number(pickGroup(match.groups.z, match.groups.h)) : undefined
	});
}

function parseDriverPoint(match, dim) {
	return omitUndefinedValues({
		srid: Number(match.groups.srid),
		x: Number(match.groups.x),
		y: Number(match.groups.y),
		z: dim === 3 ? Number(match.groups.z) : undefined
	});
}

function parsePointString(value, dim) {
	const parsers = dim === 3
		? [[wkt3DReg, parseWktPoint], [cypherPoint3DReg, parseCypherPoint], [driverPoint3DReg, parseDriverPoint]]
		: [[wkt2DReg, parseWktPoint], [cypherPoint2DReg, parseCypherPoint], [driverPoint2DReg, parseDriverPoint]];

	for (const parser of parsers) {
		const match = value.match(parser[0]);
		if (match) {
			return parser[1](match, dim);
		}
	}
	return undefined;
}

function toPointObject(value, dim, label) {
	value = tryParseObjectString(value);
	const point = _.isPlainObject(value) ? parsePointObject(value, dim) : undefined;
	if (point) {
		return point;
	}
	if (_.isString(value)) {
		const stringPoint = parsePointString(value, dim);
		if (stringPoint) {
			return stringPoint;
		}
	}
	throwPointConversionError(label);
}

function throwPointConversionError(label) {
	throw createConversionError(`Value must be a Point ${label}.`);
}

function toPoint2DObject(value) {
	return toPointObject(value, 2, '2D');
}

function toPoint3DObject(value) {
	return toPointObject(value, 3, '3D');
}

function validatePoint(point, props, srids, label) {
	if (!hasOnlyProps(point, props)) {
		throw createConversionError(`Value must be a ${label} object.`);
	}
	if (!srids.includes(point.srid)) {
		throw createConversionError(`Invalid ${label} srid.`);
	}
	if (!_.every(_.omit(point, 'srid'), _.isFinite)) {
		throw createConversionError(`${label} coordinates must be numbers.`);
	}
	return point;
}

function toLocationObject(value) {
	if (_.isPlainObject(value) && hasOnlyProps(value, typeProperties.Location)) {
		if (_.isFinite(value.latitude) && _.isFinite(value.longitude)) {
			return value;
		}
	}

	const point = toPoint2DObject(value);
	return { latitude: point.y, longitude: point.x };
}

function toArrayValue(value) {
	const parsed = _.isString(value) ? parseJsonString(value) : value;
	if (_.isArray(parsed)) {
		return parsed;
	}
	throw createConversionError('Value must be an array.');
}

function toObjectValue(value) {
	const parsed = _.isString(value) ? parseJsonString(value) : value;
	if (_.isPlainObject(parsed)) {
		return parsed;
	}
	throw createConversionError('Value must be an object.');
}

function toJsonValue(value) {
	if (_.isString(value)) {
		parseJsonString(value);
		return value;
	}
	if (_.isPlainObject(value) || _.isArray(value)) {
		return JSON.stringify(value, null, 2);
	}
	throw createConversionError('Value must be valid JSON.');
}

function convertExplicitValue(value, type, driver) {
	assertTypeSupported(type, driver);
	switch (type) {
		case 'string': return _.toString(value);
		case 'number': return toNumber(value);
		case 'boolean': return toBoolean(value);
		case 'date': return toDateObject(value);
		case 'localtime': return toLocalTimeObject(value);
		case 'time': return toTimeObject(value);
		case 'localdatetime': return toLocalDateTimeObject(value);
		case 'datetime': return toDateTimeObject(value);
		case 'array': return toArrayValue(value);
		case 'object': return toObjectValue(value);
		case 'json': return toJsonValue(value);
		case 'point2d': return validatePoint(toPoint2DObject(value), typeProperties.ValidPoint2D, [7203, 4326], 'Point 2D');
		case 'point3d': return validatePoint(toPoint3DObject(value), typeProperties.ValidPoint3D, [9157, 4979], 'Point 3D');
		case 'location': return toLocationObject(value);
		case 'duration': return toDurationObject(value, driver);
		default: throw createConversionError(`Unsupported conversion type '${type}'.`);
	}
}

function tryAutoConversion(value, type, driver) {
	if (!isTypeSupported(type, driver)) {
		return undefined;
	}
	try {
		return convertExplicitValue(value, type, driver);
	} catch {
		return undefined;
	}
}

function convertAutoValue(value, driver) {
	if (_.isFinite(value)) return value;
	if (_.isBoolean(value)) return value;
	if (_.isArray(value)) return value;

	const orderedTypes = driver === 'falkordb'
		? ['date', 'localdatetime', 'localtime', 'boolean', 'location', 'number', 'duration', 'array', 'json']
		: ['date', 'datetime', 'localdatetime', 'time', 'localtime', 'boolean', 'point3d', 'point2d', 'number', 'duration', 'array', 'json'];

	for (const type of orderedTypes) {
		const converted = tryAutoConversion(value, type, driver);
		if (converted !== undefined) {
			return converted;
		}
	}

	return _.isPlainObject(value) && isTypeSupported('object', driver)
		? value
		: _.toString(value);
}

function convertValue(value, options = {}) {
	const conversionOptions = normalizeConversionOptions(options);
	try {
		if (conversionOptions.type === 'auto') {
			return convertAutoValue(value, conversionOptions.driver);
		}
		return convertExplicitValue(value, conversionOptions.type, conversionOptions.driver);
	} catch (e) {
		if (conversionOptions.strict === false) {
			return value;
		}
		console.error('Conversion error:', e.message);
		return null;
	}
}

module.exports = {
	convertValue
};
